import type { Dictionary } from "@/dictionaries/types";
import type { AppliedChip } from "@/features/home-v2/browse/BrowseControls";
import type { CollectionItems } from "./useCollectionItems";

/** The Items tab's control vocabulary — the orders `/nfts` takes and the
 *  chips of what is in force, each removable on its own. */
export function itemControls(s: CollectionItems, b: Dictionary["browse"], opts: { locale: string; currencyName?: (id: number) => string | null }) {
  const sorts = [
    { key: "newest", label: b.sortNewest },
    { key: "oldest", label: b.sortOldest },
    { key: "price-asc", label: b.sortPriceAsc },
    { key: "price-desc", label: b.sortPriceDesc },
    { key: "likes-desc", label: b.sortLikes },
    { key: "listed-desc", label: b.sortListed },
    { key: "name-asc", label: b.sortNameAsc },
    { key: "name-desc", label: b.sortNameDesc },
  ] as const;
  const f = s.filters;
  const num = (v: string) => Number(v).toLocaleString(opts.locale, { maximumSignificantDigits: 18 });
  const range = f.priceMin && f.priceMax ? `${num(f.priceMin)} – ${num(f.priceMax)}` : f.priceMin ? `≥ ${num(f.priceMin)}` : f.priceMax ? `≤ ${num(f.priceMax)}` : "";
  const currency = f.currencyId ? opts.currencyName?.(f.currencyId) ?? null : null;
  const chips: AppliedChip[] = [
    ...(s.q ? [{ key: "q", label: s.q, onRemove: () => s.setQuery("") }] : []),
    ...(s.sort !== "newest" ? [{ key: "sort", label: sorts.find((o) => o.key === s.sort)?.label ?? s.sort, onRemove: () => s.setSort("newest") }] : []),
    ...(f.listed ? [{ key: "listed", label: f.listed === "1" ? b.statusListed : b.statusUnlisted, onRemove: () => s.setFilters({ listed: null }) }] : []),
    ...(f.hasOffers ? [{ key: "offers", label: b.hasOffers, onRemove: () => s.setFilters({ hasOffers: false }) }] : []),
    ...(f.onAuction ? [{ key: "auction", label: b.onAuction, onRemove: () => s.setFilters({ onAuction: false }) }] : []),
    ...(range ? [{ key: "price", label: b.priceRangeChip.replace("{range}", range), onRemove: () => s.setFilters({ priceMin: null, priceMax: null }) }] : []),
    ...(f.currencyId ? [{ key: "currency", label: currency ?? `${b.currencyLabel} #${f.currencyId}`, onRemove: () => s.setFilters({ currencyId: null }) }] : []),
    ...f.traits.map((p) => ({ key: `t-${p.trait}-${p.value}`, label: `${p.trait}: ${p.value}`, onRemove: () => s.toggleTrait(p) })),
  ];
  return { sorts, chips };
}
